import React from 'react';
import logo from '../../assets/logo.png';

const Branding= () => (
  <div className="hidden lg:flex lg:w-1/2 bg-indigo-400 flex-col justify-center items-center p-12 relative overflow-hidden">
    <div className="relative z-10 mb-8">
      <img src={logo} alt="Logo" className="h-32 w-auto" />
    </div>
    <div className="text-center text-white relative z-10 max-w-lg">
      <h1 className="text-4xl font-bold mb-6">Welcome to Pragya-AI</h1>
      <div className="flex justify-center space-x-4">
        <div className="flex items-center">
          <div className="bg-white rounded-full p-1 mr-2">
            <svg className="h-4 w-4 text-indigo-400" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <span className="text-sm">Talk To Your Data</span>
        </div>
      </div>
    </div>
    <div className="absolute inset-0 opacity-10">
      <svg className="h-full w-full" width="400" height="400" viewBox="0 0 400 400" fill="none">
        <g opacity="0.8">
          <circle cx="100" cy="100" r="80" stroke="white" strokeWidth="2" />
          <circle cx="300" cy="300" r="80" stroke="white" strokeWidth="2" />
          <circle cx="200" cy="200" r="150" stroke="white" strokeWidth="2" />
          <line x1="100" y1="100" x2="300" y2="300" stroke="white" strokeWidth="2" />
          <line x1="200" y1="0" x2="200" y2="400" stroke="white" strokeWidth="2" />
          <line x1="0" y1="200" x2="400" y2="200" stroke="white" strokeWidth="2" />
        </g>
      </svg>
    </div>
  </div>
);

export default Branding;
